import { render, staticRenderFns } from "./allOrder.vue?vue&type=template&id=6e50afc3&scoped=true&"
import script from "./allOrder.vue?vue&type=script&lang=js&"
export * from "./allOrder.vue?vue&type=script&lang=js&"
import style0 from "./allOrder.vue?vue&type=style&index=0&id=6e50afc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e50afc3",
  null
  
)

export default component.exports